export default __webpack_public_path__ + "static/media/astropayIcon.2064b162.svg";